import BaseSelectionArea from "./BaseSelectionArea";
import areasJson from "../data/selections/areaDefinition.json";
import fieldsJson from "../data/selections/fieldDefinition.json";
import pathsJson from "../data/selections/pathDefinition.json";

const removeFieldSelectionIfExternal = (arr) => {
  return process.env.REACT_APP_IS_EXTERNAL ? arr.slice(0, 2) : arr
}

function baseSelectionsBySelectedState( selectedState ) {
  // 全国を選択
  if (selectedState.areaId === "D0") {
    // 進学者を選択
    if (selectedState.pathId === "C0") {
      return [areasJson, pathsJson["D0"], fieldsJson["C0"]]
    // 大学・短大・専門のいずれかを選択
    } else {
      return [areasJson, pathsJson["D0"], fieldsJson[selectedState.pathId]]
    }
  // エリア別を選択
  } else {
    return [areasJson, pathsJson["D1"], fieldsJson["C0"]]
  }
}

function BaseSelectionsArea({ selectedState, onSelect = f => f }) {
  const baseSelections = removeFieldSelectionIfExternal(baseSelectionsBySelectedState(selectedState))
  const gridColsClass = process.env.REACT_APP_IS_EXTERNAL ? "grid-cols-4" : "grid-cols-6"
  const colSpanClass =  process.env.REACT_APP_IS_EXTERNAL ? "col-span-2" : "col-span-3"
  return (
    <>
      <div className={`col-span-1 ${process.env.REACT_APP_IS_EXTERNAL ? "" : "hidden"}`}></div>
      <div className={colSpanClass + " grid " + gridColsClass}>
        {
          baseSelections.map((selectElementData) => {
            return (
              <BaseSelectionArea
                selectElementData={selectElementData}
                selectedState={selectedState}
                onSelect={onSelect}
                key={selectElementData.label}
              />
            )
          })
        }
      </div>
    </>
  );
}

export default BaseSelectionsArea;
